module.exports = __webpack_public_path__ + "img/file_icon.e3e6e83.svg";